export const projectRegisterEnumList = [
  {
    title: "招标文件信息",
    list: [
      { label: "标段（包）名称：", dataIndex: "bidSectionName", span: 24 },
      { label: "开标方式：", dataIndex: "bidOpenType" },
      { label: "评定分离：", dataIndex: "isassessmentseparation", isYesOrNo: true },
      { label: "踏勘现场：", dataIndex: "isbuyconsortium", isYesOrNo: true },
      { label: "允许联合体投标：", dataIndex: "iscombo", isYesOrNo: true },
      { label: "投标保证金：", dataIndex: "marginAmount", unit: "万元" },
      { label: "报价单位：", dataIndex: "marginAmountUnit" },
      { label: "投标文件递交方法：", dataIndex: "bidDocReferMethod", span: 24 },
      { label: "招标文件获取方法：", dataIndex: "tenderDocGetMethod", span: 24 },
      { label: "投标人资格条件：", dataIndex: "bidQualification", span: 24 },
      { label: "评标方法：", dataIndex: "bidevaluationMethod" },
    ],
  },
  {
    title: "招标公告信息",
    showFlag: "1",
    list: [
      { label: "招标公告名称：", dataIndex: "bulletinName", span: 24 },
      { label: "公告发布时间：", dataIndex: "bulletinIssueTime" },
      { label: "公告结束时间：", dataIndex: "bulletinEndTime" },
      { label: "公告发布责任人：", dataIndex: "bulletinDuty" },
      { label: "公告发布媒体：", dataIndex: "bulletinMedia" },
    ],
  },
  {
    title: "投标邀请书信息",
    showFlag: "2",
    list: [
      { label: "投标邀请书名称：", dataIndex: "bulletinName", span: 24 },
      { label: "投标邀请书发布时间：", dataIndex: "bulletinIssueTime" },
      { label: "投标邀请书结束时间：", dataIndex: "bulletinEndTime" },
    ],
  },
  {
    title: "招标代理机构信息",
    list: [
      { label: "招标代理机构：", dataIndex: "tenderAgencyName", span: 24 },
      { label: "地址：", dataIndex: "tenderAgencyAddress" },
      { label: "邮编：", dataIndex: "tenderAgencyEmail" },
      { label: "联系人：", dataIndex: "tenderAgencyContactor" },
      { label: "联系电话：", dataIndex: "tenderAgencyPhoneNumber" },
    ],
  },
  {
    title: "招标时间信息",
    // twoWord: 'gcProjectPlanVo',
    list: [
      { label: "项目开标时间：", dataIndex: "bidOpenTime" },
      { label: "投标文件递交截止时间：", dataIndex: "bidDocReferEndTime" },
      { label: "招标文件获取时间：", dataIndex: "tenderDocGetStartTime" },
      { label: "招标文件获取截止时间：", dataIndex: "tenderDocGetEndTime" },
      { label: "投标有效期：", dataIndex: "validPeriod", unit: "天" },
      { label: "保证金到账截止时间：", dataIndex: "marginEndtime" },
    ],
  },
];
